import React from 'react';
import { useSelector } from 'react-redux';
import { SOCIAL_PLATFORMS } from '~/constants';
import { generateSearchContentMock } from '~/contentSearchUtils';
import { routes } from '~/core/router';
import { GradientEmptyPage } from '~/screens/MyAgency/components/StackView/GradientEmptyPage';
import { selectTalentManager } from '~/selectors/talent-manager';

import { SearchContentGrid } from './SearchContentGrid';

export const SearchContentEmptyMockResults = () => {
  const contentMock = [
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/uc587LYKxkx85uf6HhCIxAFYz80.jpg?scale-down-to=512',
      name: 'Andrea Michaels',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/k9g2V6LUGrSKYEMpW55DJhjnk.jpg',
      name: 'Andrea Michaels',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/sT6LQTuXWCLzlGEy0wyPc9FtLmA.jpg',
      name: 'Raymond Porter',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/6Q76PUpcjWsGnP8Yg2lBQxrm6xE.jpg',
      name: 'Nia Parker',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/FONdrOJNI9ddZKyEKS6Wd2pj2Sk.jpg?scale-down-to=512',
      name: 'Andrea Michaels',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/WmqXDzeU6HYWB8JvUFJ9dmiDII.jpg?scale-down-to=512',
      name: 'John Macmillan',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/KyTrPxsrZXLpw4sgv3Cd42UUdL8.jpg',
      name: 'Natalia Diaz',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/6RyjqC2TJ6hz2dk52mJ3Vf1CNfM.jpg',
      name: 'Nia Parker',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/WjHMOIvXqgkm6Pzm0QEC6ikkegI.jpg?scale-down-to=1024',
      name: 'John Macmillan',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/LFSSUqotrdA1gHEjX3guO47Gss.jpg',
      name: 'Andrea Michaels',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/4ssobDo7PB4kcM6GIytnd6bl5cU.jpg?scale-down-to=1024',
      name: 'Olivia Grant',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/VVISlgKTEDTztrh3cOeXGF7X3vM.jpg',
      name: 'Ethan Carter',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/L4Mr2g84PP0sD6RrqwxbBtiHdE.jpg',
      name: 'Raymond Porter',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/EPdvwgVI4S0HZHJDmpfO8Adf08.jpg',
      name: 'Stefan Louis',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/3XJrjT4ji5W4PTUb56LaqBAqvvg.jpg?scale-down-to=512',
      name: 'Natalia Diaz',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/GwujNBySzYdorEvrxMBlxAuAMAU.jpg?scale-down-to=1024',
      name: 'Olivia Grant',
    },
    {
      platform: SOCIAL_PLATFORMS.tiktok,
      url: 'https://framerusercontent.com/images/DVOhYcSUZbZ31nPHdEyJlMGs9o.jpg?scale-down-to=512',
      name: 'Raymond Porter',
    },
    {
      platform: SOCIAL_PLATFORMS.instagram,
      url: 'https://framerusercontent.com/images/i7KqDUXy7NCRsTug1kWzWzsE.jpg?scale-down-to=1024',
      name: 'Jake Harrison',
    },
  ];
  const hasManager = useSelector(selectTalentManager);

  return (
    <>
      <SearchContentGrid
        contents={generateSearchContentMock(contentMock)}
        onClickItem={() => {}}
      />
      <GradientEmptyPage
        infoText={
          hasManager
            ? 'Start by adding Talent to build your first pitch list, rosters, media packs, and gain access to live content and social analytics'
            : 'Connect your socials to gain access to live content analytics.'
        }
        buttonText={hasManager ? 'Add Talent' : 'Connect'}
        redirectUrl={!hasManager ? routes.platformConnections : undefined}
      />
    </>
  );
};
